import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import axios from "axios";
import { buildApiUrl } from "../utils/api";

const STATUS_COLORS = {
    'New lead': '#0d6efd',
    'Qualified': '#6f42c1',
    'Matching in progress': '#fd7e14',
    'Quote shared': '#0dcaf0',
    'Negotiation': '#ffc107',
    'Won': '#198754',
    'On hold': '#6c757d',
    'Lost': '#dc3545'
};

function WarehouseBookingList() {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBookings = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.get(buildApiUrl("/api/warehouseQuote/quoteDetails"), {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setBookings(Array.isArray(response.data) ? response.data : []);
            } catch (err) {
                console.error("Error fetching bookings:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };
        fetchBookings();
    }, []);

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        return new Date(dateStr).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    };

    return (
        <>
            <Helmet>
                <title>My Quote Requests | 3PL Search</title>
            </Helmet>

            <div className="p-3">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 style={{ color: "#132238", fontWeight: 700 }}>
                        My Quote Requests{" "}
                        {!loading && !error && (
                            <span className="badge bg-secondary fs-6">{bookings.length}</span>
                        )}
                    </h2>
                    <Link to="/finder" className="btn btn-primary btn-sm">+ Request another quote</Link>
                </div>

                {loading && <p className="text-muted">Loading your quote requests...</p>}

                {error && (
                    <div className="alert alert-warning">
                        Could not load your quote requests. Please try refreshing or <Link to="/userLogin">log in again</Link>.
                    </div>
                )}

                {!loading && !error && bookings.length === 0 && (
                    <div className="text-center py-5">
                        <p className="text-muted mb-3">You have not submitted any quote requests yet.</p>
                        <Link to="/finder" className="btn btn-primary">Browse warehouses</Link>
                    </div>
                )}

                {!loading && !error && bookings.length > 0 && (
                    <>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead className="custom-thead">
                                    <tr>
                                        <th>#</th>
                                        <th>Date</th>
                                        <th>Warehouse</th>
                                        <th>Location</th>
                                        <th>SKU</th>
                                        <th>Monthly Orders</th>
                                        <th>Sales Channels</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bookings.map((booking, index) => (
                                        <tr key={booking._id}>
                                            <td>{index + 1}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{formatDate(booking.bookingDate || booking.createdAt)}</td>
                                            <td>{booking.warehouseName}</td>
                                            <td>{booking.warehouseLocation}</td>
                                            <td>{booking.totalSKU}</td>
                                            <td>{booking.averageMonthlyOrders}</td>
                                            <td>{booking.salesChannel}</td>
                                            <td>
                                                <span style={{
                                                    display: "inline-block",
                                                    padding: "2px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "0.8rem",
                                                    fontWeight: 600,
                                                    color: "#fff",
                                                    backgroundColor: STATUS_COLORS[booking.status] || "#6c757d"
                                                }}>
                                                    {booking.status || "New lead"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-muted small mt-3">
                            <p>Your CS team reviews each request and will be in touch with shortlisted providers and quote options.</p>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default WarehouseBookingList;
